<template>
  <div>
    <div class="fileOnlyAttachment file-picker-wrapper">
      <button
        type="button"
        class="file-picker-btn"
        @click.prevent="$refs.file.click()"
      >
        <span class="file-picker-label">
          {{ selectedFileName || $t("geral.escolhaArquivo") }}
        </span>
        <span class="file-picker-action">Procurar</span>
      </button>
      <input
        id="input-field-tip-attachment"
        ref="file"
        type="file"
        class="native-file-input"
        @change="createByHandleFileUpload($event, field)"
        accept="image/*"
      />
    </div>

    <b-row class="text-center" v-if="field.tipAttachments != null">
      <b-col
        md="12"
        v-for="(attachment, i) in field.tipAttachments"
        :key="attachment.id || attachment.attachmentName || `attachment-${i}`"
      >
        <div class="attachment-div ml-3 mb-3">
          <img
            class="attachment-img-div"
            :src="attachment.attachment"
            :alt="attachment.attachmentName || 'anexo'"
          />
          <div class="mt-2 attachment-discard-div">
            <a href="#" @click.prevent="fileRemove(attachment)">
              <label class="link">{{ $t("geral.discard") }}</label>
            </a>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "FieldTipAttachments",
  props: {
    field: Object,
  },
  data() {
    return {
      selectedFileName: "",
    };
  },
  methods: {
    createAttachmentByBloc(blocContent) {
      let newGuid = this.generateUUID();
      return {
        id: newGuid,
        active: true,
        attachment: blocContent,
        attachmentName: `${newGuid}.png`,
        createdOn: this.getDateTimeNow(),
      };
    },
    getSelectedFile(changePayload) {
      if (!changePayload) return null;

      if (changePayload instanceof File) return changePayload;
      if (Array.isArray(changePayload)) return changePayload[0] || null;

      if (
        typeof changePayload.length === "number" &&
        changePayload.length > 0 &&
        changePayload[0] instanceof File
      ) {
        return changePayload[0];
      }

      if (typeof changePayload.item === "function") {
        const firstByItem = changePayload.item(0);
        if (firstByItem instanceof File) return firstByItem;
      }

      if (changePayload.target && changePayload.target.files) {
        return changePayload.target.files[0] || null;
      }

      if (changePayload.files) {
        return changePayload.files[0] || null;
      }

      return null;
    },
    resetFileInput(changePayload) {
      if (
        changePayload &&
        changePayload.target &&
        typeof changePayload.target.value !== "undefined"
      ) {
        changePayload.target.value = "";
      }

      if (this.$refs.file && typeof this.$refs.file.reset === "function") {
        this.$refs.file.reset();
      }
    },
    createByHandleFileUpload(changePayload, object) {
      if (!object) return;

      if (!Array.isArray(object.tipAttachments)) {
        this.$set(object, "tipAttachments", []);
      }

      const file = this.getSelectedFile(changePayload);
      if (!file) return;
      this.selectedFileName = file.name || "";

      const reader = new FileReader();
      reader.addEventListener(
        "load",
        () => {
          const newAttachment = this.createAttachmentByBloc(reader.result);
          const currentAttachments = Array.isArray(object.tipAttachments)
            ? object.tipAttachments
            : [];

          this.$set(object, "tipAttachments", [
            newAttachment,
            ...currentAttachments,
          ]);

          this.$forceUpdate();
          this.$nextTick(() => this.resetFileInput(changePayload));
        },
        false
      );
      reader.readAsDataURL(file);
    },
    getAttachmentIdentifier(payload) {
      if (payload == null) return null;
      if (typeof payload === "object") {
        return payload.id || payload.attachmentName || null;
      }
      return payload;
    },
    fileRemove(payload) {
      if (!this.field || !Array.isArray(this.field.tipAttachments)) return;

      const attachmentIdentifier = this.getAttachmentIdentifier(payload);
      const index = this.field.tipAttachments.findIndex((item) => {
        if (attachmentIdentifier == null) {
          return item === payload;
        }
        return (
          item.id === attachmentIdentifier ||
          item.attachmentName === attachmentIdentifier
        );
      });

      if (index >= 0) {
        const nextAttachments = this.field.tipAttachments.filter(
          (_, currentIndex) => currentIndex !== index
        );
        this.$set(this.field, "tipAttachments", nextAttachments);
      }

      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
.attachment-div {
  border: 1px solid #2b3553;
  border-radius: 0.4285rem;
  padding: 20px;
  margin-top: 10px;
  margin-bottom: 15px;
  text-align: center;
}

.attachment-img-div {
  max-width: 100%;
  max-height: 100%;
  height: 240px;
}

.attachment-discard-div {
  text-align: center;
}

.link {
  cursor: pointer;
}

.link:hover {
  color: white !important;
}

.file-picker-wrapper {
  width: 100%;
}

.file-picker-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border: 1px solid #2b3553;
  border-radius: 0.4285rem;
  background: transparent;
  color: #fff;
  min-height: 38px;
  padding: 0;
  text-align: left;
}

.file-picker-label {
  padding: 8px 12px;
  color: #9ca0b3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-picker-action {
  border-left: 1px solid #2b3553;
  padding: 8px 16px;
  color: #fff;
  flex-shrink: 0;
}

.native-file-input {
  display: none;
}
</style>
